import { createStore, createEvent } from "effector";
import { Fleet } from "../../types/fleets.types";
import { fleetsStoreState } from "./FleetsStore.consts";
import { FleetsStoreState } from "./FleetsStore.types";
import {
  addVehicleEffect,
  deleteVehicleEffect,
  editVehicleEffect,
  getFleetsEffect,
  getFleetsByClientEffect,
} from "./FleetsStore.effects";

export const setFleets = createEvent<Fleet[]>("setFleets");
export const resetFleetsStore = createEvent();

export const FleetsStore = createStore<FleetsStoreState>(fleetsStoreState)
  .on(getFleetsEffect.doneData, (store, fleets: Fleet[]) => ({ ...store, fleets }))
  .on(getFleetsByClientEffect.doneData, (store, fleets: Fleet[]) => ({ ...store, fleets }))
  .on(addVehicleEffect.doneData, (store, newFleet: Fleet) => ({
    ...store,
    fleets: [...store.fleets, newFleet],
  }))
  .on(editVehicleEffect.doneData, (store, editedFleet: Fleet) => ({
    ...store,
    fleets: store.fleets.map((f) => (f.id === editedFleet.id ? editedFleet : f)),
  }))
  .on(deleteVehicleEffect.doneData, (store, deletedId: string) => ({
    ...store,
    fleets: store.fleets.filter((f) => f.id !== deletedId),
  }))
  .reset(resetFleetsStore);
